import React, { Component } from "react";

export default class RugSettingsSidebar extends Component {
  render() {
    const { stepOnboarding } = this.props;

    return (
      <div
        className="text-center select-structure-normal-display"
        style={{ zIndex: stepOnboarding === 3 ? 1 : 0 }}
      >
        <ul className="normal-display">
          <li
            className={`${
              this.props.activeType === "lachak-toranj" ? "active" : ""
            } ${this.props.themeDirection == "ltr" ? "item-EN" : ""}`}
            id="lachak-toranj"
            onClick={() => {
              this.props.carpetTypeHandler("lachak-toranj");
            }}
          >
            <svg viewBox="0 0 32 48" version="1.1">
              <g transform="matrix(1,0,0,1,-3609.02,-3470.74)">
                <g transform="matrix(1,0,0,1,-4920.71,2854.89)">
                  <g transform="matrix(3.49957e-18,-0.0571524,0.0606951,3.71651e-18,8506.49,689.656)">
                    <rect
                      x="474.416"
                      y="391.142"
                      width="807.127"
                      height="506.676"
                      style={{ fill: "white", strokeWidth: "16.96px" }}
                    />
                  </g>
                </g>
                <g transform="matrix(1,0,0,1,-4920.71,2854.89)">
                  <g transform="matrix(3.4882e-18,-0.0569666,0.0569666,3.4882e-18,8511.08,685.019)">
                    <path
                      d="M394.569,336.198L1204.33,336.198L1204.33,776.975L1205.43,776.975L1205.43,876.036L395.673,876.036L395.673,868.871L394.569,868.871L394.569,435.259L394.569,336.198ZM493.63,435.259L493.63,776.975L1105.27,776.975L1105.27,435.259L493.63,435.259Z"
                      style={{ fill: "white", strokeWidth: "17.55px" }}
                    />
                  </g>
                </g>
                <g transform="matrix(1,0,0,1,-4920.71,2854.89)">
                  <g transform="matrix(2.63475e-18,-0.0430287,0.0360383,2.20671e-18,8523.79,673.876)">
                    <path
                      d="M1203.22,875.484L1007.31,875.484L1203.22,679.569L1203.22,875.484ZM395.673,678.466L395.673,874.381L591.588,874.381L395.673,678.466ZM1204.33,533.216L1008.41,337.301L1204.33,337.301L1204.33,533.216ZM394.569,532.112L394.569,336.198L590.484,336.198L394.569,532.112Z"
                      style={{ fill: "white", strokeWidth: "25.2px" }}
                    />
                  </g>
                </g>
                <g transform="matrix(1,0,0,1,-4920.71,2854.89)">
                  <g transform="matrix(1.17797e-17,-0.192378,0.091526,5.60435e-18,8497.65,770.249)">
                    <path
                      d="M748.418,523.966L679.77,604.45L611.121,523.966L679.77,443.482L748.418,523.966Z"
                      style={{ fill: "white", strokeWidth: "6.64px" }}
                    />
                  </g>
                </g>
              </g>
            </svg>
            <span>{this.props.texts["lachakToranj"]}</span>
          </li>
          <li
            className={`${this.props.activeType === "afshan" ? "active" : ""} ${
              this.props.themeDirection == "ltr" ? "item-EN" : ""
            }`}
            id="afshan"
            onClick={() => {
              this.props.carpetTypeHandler("afshan");
            }}
          >
            <svg viewBox="0 0 32 48" version="1.1">
              <g transform="matrix(1,0,0,1,-3608.99,-3554.11)">
                <g transform="matrix(1,0,0,1,-4920.71,2854.89)">
                  <g transform="matrix(3.49957e-18,-0.0571524,0.0606951,3.71651e-18,8506.46,773.021)">
                    <rect
                      x="474.416"
                      y="391.142"
                      width="807.127"
                      height="506.676"
                      style={{ fill: "white", strokeWidth: "16.96px" }}
                    />
                  </g>
                </g>
                <g transform="matrix(1,0,0,1,-4920.71,2854.89)">
                  <g transform="matrix(3.4882e-18,-0.0569666,0.0569666,3.4882e-18,8511.04,768.384)">
                    <path
                      d="M394.569,336.198L1204.33,336.198L1204.33,776.975L1205.43,776.975L1205.43,876.036L395.673,876.036L395.673,868.871L394.569,868.871L394.569,435.259L394.569,336.198ZM493.63,435.259L493.63,776.975L1105.27,776.975L1105.27,435.259L493.63,435.259Z"
                      style={{ fill: "white", strokeWidth: "17.55px" }}
                    />
                  </g>
                </g>
              </g>
            </svg>
            <span className="pt-1">{this.props.texts["afshan"]}</span>
          </li>
          <li
            className={`${
              this.props.activeType === "kheshti" ? "active" : ""
            } ${this.props.themeDirection == "ltr" ? "item-EN" : ""}`}
            id="kheshti"
            onClick={() => {
              this.props.carpetTypeHandler("kheshti");
            }}
          >
            <svg viewBox="0 0 32 48" version="1.1">
              <g transform="matrix(1,0,0,1,-3608.99,-3639.69)">
                <g transform="matrix(1,0,0,1,-4920.71,2854.89)">
                  <g transform="matrix(3.49957e-18,-0.0571524,0.0606951,3.71651e-18,8506.46,858.54)">
                    <rect
                      x="474.416"
                      y="391.142"
                      width="807.127"
                      height="506.676"
                      style={{ fill: "white", strokeWidth: "16.96px" }}
                    />
                  </g>
                </g>
                <g transform="matrix(1,0,0,1,-4920.71,2854.89)">
                  <g transform="matrix(0.686243,0,0,0.686243,7092.58,-771.819)">
                    <rect
                      x="2097.94"
                      y="2273.6"
                      width="9.685"
                      height="9.685"
                      style={{ stroke: "white", strokeWidth: "2.19px" }}
                    />
                  </g>
                </g>
                <g transform="matrix(1,0,0,1,-4920.71,2854.89)">
                  <g transform="matrix(0.686243,0,0,0.686243,7092.58,-765.173)">
                    <rect
                      x="2097.94"
                      y="2273.6"
                      width="9.685"
                      height="9.685"
                      style={{ stroke: "white", strokeWidth: "2.19px" }}
                    />
                  </g>
                </g>
                <g transform="matrix(1,0,0,1,-4920.71,2854.89)">
                  <g transform="matrix(0.686243,0,0,0.686243,7092.58,-758.527)">
                    <rect
                      x="2097.94"
                      y="2273.6"
                      width="9.685"
                      height="9.685"
                      style={{ stroke: "white", strokeWidth: "2.19px" }}
                    />
                  </g>
                </g>
                <g transform="matrix(1,0,0,1,-4920.71,2854.89)">
                  <g transform="matrix(0.686243,0,0,0.686243,7092.58,-751.881)">
                    <rect
                      x="2097.94"
                      y="2273.6"
                      width="9.685"
                      height="9.685"
                      style={{ stroke: "white", strokeWidth: "2.19px" }}
                    />
                  </g>
                </g>
                <g transform="matrix(1,0,0,1,-4920.71,2854.89)">
                  <g transform="matrix(0.686243,0,0,0.686243,7092.58,-745.235)">
                    <rect
                      x="2097.94"
                      y="2273.6"
                      width="9.685"
                      height="9.685"
                      style={{ stroke: "white", strokeWidth: "2.19px" }}
                    />
                  </g>
                </g>
                <g transform="matrix(1,0,0,1,-4920.71,2854.89)">
                  <g transform="matrix(0.686243,0,0,0.686243,7092.58,-738.589)">
                    <rect
                      x="2097.94"
                      y="2273.6"
                      width="9.685"
                      height="9.685"
                      style={{ stroke: "white", strokeWidth: "2.19px" }}
                    />
                  </g>
                </g>
                <g transform="matrix(1,0,0,1,-4920.71,2854.89)">
                  <g transform="matrix(0.686243,0,0,0.686243,7105.87,-771.819)">
                    <rect
                      x="2097.94"
                      y="2273.6"
                      width="9.685"
                      height="9.685"
                      style={{ stroke: "white", strokeWidth: "2.19px" }}
                    />
                  </g>
                </g>
                <g transform="matrix(1,0,0,1,-4920.71,2854.89)">
                  <g transform="matrix(0.686243,0,0,0.686243,7105.87,-765.173)">
                    <rect
                      x="2097.94"
                      y="2273.6"
                      width="9.685"
                      height="9.685"
                      style={{ stroke: "white", strokeWidth: "2.19px" }}
                    />
                  </g>
                </g>
                <g transform="matrix(1,0,0,1,-4920.71,2854.89)">
                  <g transform="matrix(0.686243,0,0,0.686243,7105.87,-758.527)">
                    <rect
                      x="2097.94"
                      y="2273.6"
                      width="9.685"
                      height="9.685"
                      style={{ stroke: "white", strokeWidth: "2.19px" }}
                    />
                  </g>
                </g>
                <g transform="matrix(1,0,0,1,-4920.71,2854.89)">
                  <g transform="matrix(0.686243,0,0,0.686243,7105.87,-751.881)">
                    <rect
                      x="2097.94"
                      y="2273.6"
                      width="9.685"
                      height="9.685"
                      style={{ stroke: "white", strokeWidth: "2.19px" }}
                    />
                  </g>
                </g>
                <g transform="matrix(1,0,0,1,-4920.71,2854.89)">
                  <g transform="matrix(0.686243,0,0,0.686243,7105.87,-745.235)">
                    <rect
                      x="2097.94"
                      y="2273.6"
                      width="9.685"
                      height="9.685"
                      style={{ stroke: "white", strokeWidth: "2.19px" }}
                    />
                  </g>
                </g>
                <g transform="matrix(1,0,0,1,-4920.71,2854.89)">
                  <g transform="matrix(0.686243,0,0,0.686243,7105.87,-738.589)">
                    <rect
                      x="2097.94"
                      y="2273.6"
                      width="9.685"
                      height="9.685"
                      style={{ stroke: "white", strokeWidth: "2.19px" }}
                    />
                  </g>
                </g>
                <g transform="matrix(1,0,0,1,-4920.71,2854.89)">
                  <g transform="matrix(0.686243,0,0,0.686243,7099.23,-771.819)">
                    <rect
                      x="2097.94"
                      y="2273.6"
                      width="9.685"
                      height="9.685"
                      style={{ stroke: "white", strokeWidth: "2.19px" }}
                    />
                  </g>
                </g>
                <g transform="matrix(1,0,0,1,-4920.71,2854.89)">
                  <g transform="matrix(0.686243,0,0,0.686243,7099.23,-765.173)">
                    <rect
                      x="2097.94"
                      y="2273.6"
                      width="9.685"
                      height="9.685"
                      style={{ stroke: "white", strokeWidth: "2.19px" }}
                    />
                  </g>
                </g>
                <g transform="matrix(1,0,0,1,-4920.71,2854.89)">
                  <g transform="matrix(0.686243,0,0,0.686243,7099.23,-758.527)">
                    <rect
                      x="2097.94"
                      y="2273.6"
                      width="9.685"
                      height="9.685"
                      style={{ stroke: "white", strokeWidth: "2.19px" }}
                    />
                  </g>
                </g>
                <g transform="matrix(1,0,0,1,-4920.71,2854.89)">
                  <g transform="matrix(0.686243,0,0,0.686243,7099.23,-751.881)">
                    <rect
                      x="2097.94"
                      y="2273.6"
                      width="9.685"
                      height="9.685"
                      style={{ stroke: "white", strokeWidth: "2.19px" }}
                    />
                  </g>
                </g>
                <g transform="matrix(1,0,0,1,-4920.71,2854.89)">
                  <g transform="matrix(0.686243,0,0,0.686243,7099.23,-745.235)">
                    <rect
                      x="2097.94"
                      y="2273.6"
                      width="9.685"
                      height="9.685"
                      style={{ stroke: "white", strokeWidth: "2.19px" }}
                    />
                  </g>
                </g>
                <g transform="matrix(1,0,0,1,-4920.71,2854.89)">
                  <g transform="matrix(0.686243,0,0,0.686243,7099.23,-738.589)">
                    <rect
                      x="2097.94"
                      y="2273.6"
                      width="9.685"
                      height="9.685"
                      style={{ stroke: "white", strokeWidth: "2.19px" }}
                    />
                  </g>
                </g>
                <g transform="matrix(1,0,0,1,-4920.71,2854.89)">
                  <g transform="matrix(0.686243,0,0,0.686243,7112.52,-771.819)">
                    <rect
                      x="2097.94"
                      y="2273.6"
                      width="9.685"
                      height="9.685"
                      style={{ stroke: "white", strokeWidth: "2.19px" }}
                    />
                  </g>
                </g>
                <g transform="matrix(1,0,0,1,-4920.71,2854.89)">
                  <g transform="matrix(0.686243,0,0,0.686243,7112.52,-765.173)">
                    <rect
                      x="2097.94"
                      y="2273.6"
                      width="9.685"
                      height="9.685"
                      style={{ stroke: "white", strokeWidth: "2.19px" }}
                    />
                  </g>
                </g>
                <g transform="matrix(1,0,0,1,-4920.71,2854.89)">
                  <g transform="matrix(0.686243,0,0,0.686243,7112.52,-758.527)">
                    <rect
                      x="2097.94"
                      y="2273.6"
                      width="9.685"
                      height="9.685"
                      style={{ stroke: "white", strokeWidth: "2.19px" }}
                    />
                  </g>
                </g>
                <g transform="matrix(1,0,0,1,-4920.71,2854.89)">
                  <g transform="matrix(0.686243,0,0,0.686243,7112.52,-751.881)">
                    <rect
                      x="2097.94"
                      y="2273.6"
                      width="9.685"
                      height="9.685"
                      style={{ stroke: "white", strokeWidth: "2.19px" }}
                    />
                  </g>
                </g>
                <g transform="matrix(1,0,0,1,-4920.71,2854.89)">
                  <g transform="matrix(0.686243,0,0,0.686243,7112.52,-745.235)">
                    <rect
                      x="2097.94"
                      y="2273.6"
                      width="9.685"
                      height="9.685"
                      style={{ stroke: "white", strokeWidth: "2.19px" }}
                    />
                  </g>
                </g>
                <g transform="matrix(1,0,0,1,-4920.71,2854.89)">
                  <g transform="matrix(0.686243,0,0,0.686243,7112.52,-738.589)">
                    <rect
                      x="2097.94"
                      y="2273.6"
                      width="9.685"
                      height="9.685"
                      style={{ stroke: "white", strokeWidth: "2.19px" }}
                    />
                  </g>
                </g>
              </g>
            </svg>
            <span className="pt-1">{this.props.texts["kheshti"]}</span>
          </li>
          <li
            className={`${this.props.activeType === "modern" ? "active" : ""} ${
              this.props.themeDirection == "ltr" ? "item-EN" : ""
            }`}
            id="modern"
            onClick={() => {
              this.props.carpetTypeHandler("modern");
            }}
          >
            <svg viewBox="0 0 32 48" version="1.1">
              <g transform="matrix(1,0,0,1,-3608.99,-3639.69)">
                <g transform="matrix(1,0,0,1,-4920.71,2854.89)">
                  <g transform="matrix(3.49957e-18,-0.0571524,0.0606951,3.71651e-18,8506.46,858.54)">
                    <rect
                      x="474.416"
                      y="391.142"
                      width="807.127"
                      height="506.676"
                      style={{ fill: "white", strokeWidth: "16.96px" }}
                    />
                  </g>
                </g>
                <g transform="matrix(1,0,0,1,-4920.71,2854.89)">
                  <g transform="matrix(0.686243,0,0,0.686243,7092.58,-771.819)">
                    <rect
                      x="2097.94"
                      y="2273.6"
                      width="9.685"
                      height="9.685"
                      style={{ stroke: "white", strokeWidth: "2.19px" }}
                    />
                  </g>
                </g>
                <g transform="matrix(1,0,0,1,-4920.71,2854.89)">
                  <g transform="matrix(0.686243,0,0,0.686243,7092.58,-765.173)">
                    <rect
                      x="2097.94"
                      y="2273.6"
                      width="9.685"
                      height="9.685"
                      style={{ stroke: "white", strokeWidth: "2.19px" }}
                    />
                  </g>
                </g>
                <g transform="matrix(1,0,0,1,-4920.71,2854.89)">
                  <g transform="matrix(0.686243,0,0,0.686243,7092.58,-758.527)">
                    <rect
                      x="2097.94"
                      y="2273.6"
                      width="9.685"
                      height="9.685"
                      style={{ stroke: "white", strokeWidth: "2.19px" }}
                    />
                  </g>
                </g>
                <g transform="matrix(1,0,0,1,-4920.71,2854.89)">
                  <g transform="matrix(0.686243,0,0,0.686243,7092.58,-751.881)">
                    <rect
                      x="2097.94"
                      y="2273.6"
                      width="9.685"
                      height="9.685"
                      style={{ stroke: "white", strokeWidth: "2.19px" }}
                    />
                  </g>
                </g>
                <g transform="matrix(1,0,0,1,-4920.71,2854.89)">
                  <g transform="matrix(0.686243,0,0,0.686243,7092.58,-745.235)">
                    <rect
                      x="2097.94"
                      y="2273.6"
                      width="9.685"
                      height="9.685"
                      style={{ stroke: "white", strokeWidth: "2.19px" }}
                    />
                  </g>
                </g>
                <g transform="matrix(1,0,0,1,-4920.71,2854.89)">
                  <g transform="matrix(0.686243,0,0,0.686243,7092.58,-738.589)">
                    <rect
                      x="2097.94"
                      y="2273.6"
                      width="9.685"
                      height="9.685"
                      style={{ stroke: "white", strokeWidth: "2.19px" }}
                    />
                  </g>
                </g>
                <g transform="matrix(1,0,0,1,-4920.71,2854.89)">
                  <g transform="matrix(0.686243,0,0,0.686243,7105.87,-771.819)">
                    <rect
                      x="2097.94"
                      y="2273.6"
                      width="9.685"
                      height="9.685"
                      style={{ stroke: "white", strokeWidth: "2.19px" }}
                    />
                  </g>
                </g>
                <g transform="matrix(1,0,0,1,-4920.71,2854.89)">
                  <g transform="matrix(0.686243,0,0,0.686243,7105.87,-765.173)">
                    <rect
                      x="2097.94"
                      y="2273.6"
                      width="9.685"
                      height="9.685"
                      style={{ stroke: "white", strokeWidth: "2.19px" }}
                    />
                  </g>
                </g>
                <g transform="matrix(1,0,0,1,-4920.71,2854.89)">
                  <g transform="matrix(0.686243,0,0,0.686243,7105.87,-758.527)">
                    <rect
                      x="2097.94"
                      y="2273.6"
                      width="9.685"
                      height="9.685"
                      style={{ stroke: "white", strokeWidth: "2.19px" }}
                    />
                  </g>
                </g>
                <g transform="matrix(1,0,0,1,-4920.71,2854.89)">
                  <g transform="matrix(0.686243,0,0,0.686243,7105.87,-751.881)">
                    <rect
                      x="2097.94"
                      y="2273.6"
                      width="9.685"
                      height="9.685"
                      style={{ stroke: "white", strokeWidth: "2.19px" }}
                    />
                  </g>
                </g>
                <g transform="matrix(1,0,0,1,-4920.71,2854.89)">
                  <g transform="matrix(0.686243,0,0,0.686243,7105.87,-745.235)">
                    <rect
                      x="2097.94"
                      y="2273.6"
                      width="9.685"
                      height="9.685"
                      style={{ stroke: "white", strokeWidth: "2.19px" }}
                    />
                  </g>
                </g>
                <g transform="matrix(1,0,0,1,-4920.71,2854.89)">
                  <g transform="matrix(0.686243,0,0,0.686243,7105.87,-738.589)">
                    <rect
                      x="2097.94"
                      y="2273.6"
                      width="9.685"
                      height="9.685"
                      style={{ stroke: "white", strokeWidth: "2.19px" }}
                    />
                  </g>
                </g>
                <g transform="matrix(1,0,0,1,-4920.71,2854.89)">
                  <g transform="matrix(0.686243,0,0,0.686243,7099.23,-771.819)">
                    <rect
                      x="2097.94"
                      y="2273.6"
                      width="9.685"
                      height="9.685"
                      style={{ stroke: "white", strokeWidth: "2.19px" }}
                    />
                  </g>
                </g>
                <g transform="matrix(1,0,0,1,-4920.71,2854.89)">
                  <g transform="matrix(0.686243,0,0,0.686243,7099.23,-765.173)">
                    <rect
                      x="2097.94"
                      y="2273.6"
                      width="9.685"
                      height="9.685"
                      style={{ stroke: "white", strokeWidth: "2.19px" }}
                    />
                  </g>
                </g>
                <g transform="matrix(1,0,0,1,-4920.71,2854.89)">
                  <g transform="matrix(0.686243,0,0,0.686243,7099.23,-758.527)">
                    <rect
                      x="2097.94"
                      y="2273.6"
                      width="9.685"
                      height="9.685"
                      style={{ stroke: "white", strokeWidth: "2.19px" }}
                    />
                  </g>
                </g>
                <g transform="matrix(1,0,0,1,-4920.71,2854.89)">
                  <g transform="matrix(0.686243,0,0,0.686243,7099.23,-751.881)">
                    <rect
                      x="2097.94"
                      y="2273.6"
                      width="9.685"
                      height="9.685"
                      style={{ stroke: "white", strokeWidth: "2.19px" }}
                    />
                  </g>
                </g>
                <g transform="matrix(1,0,0,1,-4920.71,2854.89)">
                  <g transform="matrix(0.686243,0,0,0.686243,7099.23,-745.235)">
                    <rect
                      x="2097.94"
                      y="2273.6"
                      width="9.685"
                      height="9.685"
                      style={{ stroke: "white", strokeWidth: "2.19px" }}
                    />
                  </g>
                </g>
                <g transform="matrix(1,0,0,1,-4920.71,2854.89)">
                  <g transform="matrix(0.686243,0,0,0.686243,7099.23,-738.589)">
                    <rect
                      x="2097.94"
                      y="2273.6"
                      width="9.685"
                      height="9.685"
                      style={{ stroke: "white", strokeWidth: "2.19px" }}
                    />
                  </g>
                </g>
                <g transform="matrix(1,0,0,1,-4920.71,2854.89)">
                  <g transform="matrix(0.686243,0,0,0.686243,7112.52,-771.819)">
                    <rect
                      x="2097.94"
                      y="2273.6"
                      width="9.685"
                      height="9.685"
                      style={{ stroke: "white", strokeWidth: "2.19px" }}
                    />
                  </g>
                </g>
                <g transform="matrix(1,0,0,1,-4920.71,2854.89)">
                  <g transform="matrix(0.686243,0,0,0.686243,7112.52,-765.173)">
                    <rect
                      x="2097.94"
                      y="2273.6"
                      width="9.685"
                      height="9.685"
                      style={{ stroke: "white", strokeWidth: "2.19px" }}
                    />
                  </g>
                </g>
                <g transform="matrix(1,0,0,1,-4920.71,2854.89)">
                  <g transform="matrix(0.686243,0,0,0.686243,7112.52,-758.527)">
                    <rect
                      x="2097.94"
                      y="2273.6"
                      width="9.685"
                      height="9.685"
                      style={{ stroke: "white", strokeWidth: "2.19px" }}
                    />
                  </g>
                </g>
                <g transform="matrix(1,0,0,1,-4920.71,2854.89)">
                  <g transform="matrix(0.686243,0,0,0.686243,7112.52,-751.881)">
                    <rect
                      x="2097.94"
                      y="2273.6"
                      width="9.685"
                      height="9.685"
                      style={{ stroke: "white", strokeWidth: "2.19px" }}
                    />
                  </g>
                </g>
                <g transform="matrix(1,0,0,1,-4920.71,2854.89)">
                  <g transform="matrix(0.686243,0,0,0.686243,7112.52,-745.235)">
                    <rect
                      x="2097.94"
                      y="2273.6"
                      width="9.685"
                      height="9.685"
                      style={{ stroke: "white", strokeWidth: "2.19px" }}
                    />
                  </g>
                </g>
                <g transform="matrix(1,0,0,1,-4920.71,2854.89)">
                  <g transform="matrix(0.686243,0,0,0.686243,7112.52,-738.589)">
                    <rect
                      x="2097.94"
                      y="2273.6"
                      width="9.685"
                      height="9.685"
                      style={{ stroke: "white", strokeWidth: "2.19px" }}
                    />
                  </g>
                </g>
              </g>
            </svg>
            <span className="pt-1">{this.props.texts["modern"]}</span>
          </li>
        </ul>
      </div>
    );
  }
}
